import { useEffect, useState } from "react";
import { Block, BlockHeader, BlockTitle, List, ListItem, Navbar, Page } from "konsta/react";
import TabBar from "../components/TabBar";
import { useAppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { formatUSD } from "../utils";

const ReferralPage = () => {
    const {referralResult} = useAppContext()
    const navigate = useNavigate()
    const [totalEarnings, setTotalEarnings] = useState(0)

    useEffect(() => {
      if (referralResult && referralResult.referralStats) {
        let _total = 0;
        for(const r of referralResult.referralStats) {
          _total += r.totalBalance;
        }

        setTotalEarnings(_total)
      }
    }, [referralResult])

    return (
      <Page className="select-none pb-40">
        {referralResult && <>
          <Navbar
            title="Referrals"
            className="top-0 sticky translucent"
            left={<FaArrowLeftLong className="mx-3 w-5 h-5" onClick={() => navigate(-1)}/>}
          />

{/* Earnings */}
          {referralResult && referralResult.referralStats.length > 0 && totalEarnings > 0 && <>
            <List strong outline>
              <ListItem 
                    title={`Referral Balance`}
                    subtitle={`Earnings from your referrals`}
                    after={<span className="currency text-primary text-lg">{formatUSD(totalEarnings, 6)}</span>}
                  />
            </List>

            <BlockTitle>Earnings</BlockTitle>
            <List strong outline>
                {referralResult && referralResult.referralStats.map(rs => <ListItem 
                  title={`Level ${rs.level}`}
                  subtitle={`${rs.count} users`}
                  after={<span className="currency text-primary text-lg">{formatUSD(rs.totalBalance, 6)}</span>}
                />)}
            </List>
          </>}

{/* Projected earnings */}
          {referralResult.projectedEarningsPerDay > -1 && <>
            <BlockTitle>Projected Earnings</BlockTitle>
            <BlockHeader>Projected earnings from your referrals. Actual earnings may vary.</BlockHeader>
            <List strong outline>
                <ListItem title="Daily" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay, 6)}</span>}/>
                <ListItem title="Weekly" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay * 7, 6)}</span>}/>
                <ListItem title="Bi-weekly" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay * 14, 6)}</span>}/>
                <ListItem title="Monthly" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay * 30, 6)}</span>}/>
                <ListItem title="Semi-annually" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay * 182.5, 6)}</span>}/>
                <ListItem title="Annually" after={<span className="currency text-primary text-lg">{formatUSD(referralResult.projectedEarningsPerDay * 365, 6)}</span>}/>
            </List>
          </>}


          <br/>
          <br/>
          <br/>
          <br/>
        </>}
        <TabBar selectedTab="profile"/>
      </Page>
    );
  };
  
  export default ReferralPage;
  